import React, { useState } from 'react'
import AOS from "aos"; // Import AOS library
import MapSec from '../sections/map/MapSec'
import CustomHelmet from '../components/CustomHelmet'
import * as constants from "../constants";
import { fetchAPI } from '../helper/fetchAPI';
import FullScreenLoader from '../components/FullScreenLoader';
import { useTranslation } from 'react-i18next';
import { useCountryPrefix } from '../routes/useCountryPrefix';

const Map = () => {

    let apiUrl = process.env.REACT_APP_API_URL;
    const { i18n } = useTranslation();
    const countryPrefix = useCountryPrefix();

    const [projectLatLong, setProjectLatLong] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);

    const fetchData = async () => {
        const isArabic = i18n.language === "ar";
        const language = isArabic ? "ar" : "en";

        try {
            apiUrl = `${apiUrl}${constants.projectslatlong}?language=${language}&region_id=${countryPrefix}`;
            const res = await fetchAPI(apiUrl, "Get");
            if (res?.status === 200) {

                setProjectLatLong(res?.data)
                setIsLoaded(true)
            } else {
                setIsLoaded(true)
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }

    React.useEffect(() => {
        AOS.init();

        fetchData();
    }, []);

    if (!isLoaded) {
        return (
            <FullScreenLoader />
        )
    }


    return (
        <>
            <CustomHelmet
                title={"Exclusive Real Estate Across Egypt"}
                desc={'Connect Homes makes exploring real estate in Egypt simple and seamless.'}
            />

            <MapSec projectLatLong={projectLatLong} />
        </>

    )
}

export default Map